import { render, staticRenderFns } from "./featuresOne.vue?vue&type=template&id=6d072e04&"
import script from "./featuresOne.vue?vue&type=script&lang=js&"
export * from "./featuresOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports